/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" @select="handleSelect" collapse-transition router
           :unique-opened="true"
           :default-active="$route.path" class="el-menu-vertical-demo" background-color="#fff"
           text-color="#333333" active-text-color="#409EFF">
    <template v-for="menu in allmenu">
      <el-submenu v-if="menu.children" :key="menu.id" :index="menu.func_name">
        <template slot="title">
          <i class="iconfont" :class="activeUrl==menu.func_url?menu.icon_active:menu.icon"></i>
          <span>{{menu.func_name}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="chmenu in menu.children" :index="chmenu.func_url" :key="chmenu.menuid"
                        @click="clickMenu(chmenu)">
            <span>{{chmenu.func_name}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item v-else :index="menu.func_url" @click="clickMenu(menu)">
        <i class="iconfont" :class="activeUrl==menu.func_url?menu.icon_active:menu.icon"></i>
        <span slot="title">{{menu.func_name}}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>
<script>
  import {roleGetPermissionListByUser} from "../api/basisMG";

  export default {
    func_name: 'leftnav',
    data() {
      return {
        collapsed: false,
        allmenu: [],
        activeUrl: '/Document/typeDocument',
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.activeUrl = localStorage.getItem('path')
      // 获取图形验证码
      let res = {
        success: true,
        data: [
          // {
          //   menuid: 1,
          //   icon: 'home',
          //   iconActive: 'home-active',
          //   func_name: '首页',
          //   hasThird: null,
          //   func_url: '/dashboard/Dashboard',
          //   menus: []
          // },
          {
            menuid: 10,
            icon: 'Document',
            iconActive: 'Document-active',
            func_name: 'API文档管理',
            hasThird: null,
            func_url: null,
            menus: [
              {
                menuid: 11,
                func_name: 'API类型管理',
                hasThird: 'N',
                func_url: '/Document/typeDocument',
                menus: null
              },
              {
                menuid: 12,
                func_name: '开发文档管理',
                hasThird: 'N',
                func_url: '/Document/developDocument',
                menus: null
              }
            ]
          },
          {
            menuid: 190,
            icon: 'power',
            iconActive: 'power-active',
            func_name: '权限管理',
            hasThird: null,
            func_url: null,
            menus: [
              // {
              //   menuid: 191,
              //   func_name: '账号管理',
              //   hasThird: 'N',
              //   func_url: '/power/account',
              //   menus: null
              // },
              {
                menuid: 192,
                func_name: '角色管理',
                hasThird: 'N',
                func_url: '/power/role',
                menus: null
              },
            ]
          },
          // {
          //   menuid: 200,
          //   icon: 'customer',
          //   iconActive: 'customer-active',
          //   func_name: '客服系统',
          //   hasThird: null,
          //   func_url: '/customer/customer',
          //   menus: []
          // },
        ],
        msg: 'success'
      }
      roleGetPermissionListByUser()
        .then(res => {
          if (res.success == false) {
          } else {
            this.allmenu = res.content
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })

      // 监听
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
    },
    updated() {
      this.activeUrl = localStorage.getItem('path')
    },
    methods: {
      handleSelect(key, keyPath) {
        this.activeUrl = key;
        localStorage.setItem('path', key)
      },
      clickMenu(item) {
        this.$store.commit("selectMenu", item);
      },
    }
  }
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .home {
    background: url("/static/img/docCenter/home.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .home-active {
    background: url("/static/img/docCenter/home-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Document {
    background: url("/static/img/docCenter/document.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Document-active {
    background: url("/static/img/docCenter/document-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .power {
    background: url("../../static/img/docCenter/power.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .power-active {
    background: url("../../static/img/docCenter/power-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #1f2d3d !important;
  }

  .el-menu {
    border: none;
  }

  .el-menu::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .el-menu {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 20px 0px;
  }

  .logoimg {
    height: 40px;
  }

  .text-active {
    color: #409EFF;
  }

  .asideshow {
    border: none;
  }

  .asideshow::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .asideshow {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
    border-top: solid 1px #e6e6e6;
  }

  .ads-box img {
    width: 100%;
    cursor: pointer;
  }

  .pr {
    position: relative;
  }

  .colse {
    position: absolute;
    top: 2px;
    right: 2px;
    font-size: 12px;
    padding: 2px 5px;
    color: #fff;
    border-radius: 2px;
    background: rgba(12, 25, 61, 0.4);
    cursor: pointer;

  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue